import React, { FC, useState } from "react";
import { ClickAwayListener, Tooltip } from "@material-ui/core";

export const ControlledTooltip: FC<any> = (props: any) => {
  const { title, className } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Tooltip
        className={className}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        title={title}
        PopperProps={{
          disablePortal: false,
        }}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        arrow
        placement="top"
      >
        <i onClick={handleOpen}>{props.children}</i>
      </Tooltip>
    </ClickAwayListener>
  );
};
